import { Row, Empty } from 'antd'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import emptyImage from '../../../assets/img/empty.png'
import MessageBoxSkeleton from '../skeletons/MessageBoxSkeleton'

export default function MessageBox() {
  const { dataSource, handleJumpMessageCenter, jumpOrderPage, spinning } =
    useSetupHook()

  return spinning ? (
    <MessageBoxSkeleton />
  ) : (
    <div className={styles['container']}>
      <Row className={styles['header']} justify="space-between">
        <span className={styles['title']}>消息通知</span>
        <span className="btn-link" onClick={handleJumpMessageCenter}>
          {'查看全部 >>'}
        </span>
      </Row>
      <div className={styles['messageList']}>
        {dataSource.length === 0 ? (
          <div className={styles.emptyWrapper}>
            <Empty
              image={emptyImage}
              description="暂时没有新消息"
              imageStyle={{
                height: '200px',
              }}
            />
          </div>
        ) : (
          dataSource.map((record) => {
            const displayText =
              record.title && record.title.trim() !== ''
                ? record.title
                : record.content
            return (
              <div
                key={record.id}
                className={styles['messageItem']}
                onClick={() => jumpOrderPage(record)}
              >
                <div
                  className={`${styles['messageTitle']} ${
                    record?.isRead ? styles['read'] : styles['unread']
                  }`}
                >
                  {displayText}
                </div>
                <div className={styles['messageTime']}>{record.time}</div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
import { Row, Empty } from 'antd'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import emptyImage from '../../../assets/img/empty.png'
import MessageBoxSkeleton from '../skeletons/MessageBoxSkeleton'

export default function MessageBox() {
  const { dataSource, handleJumpMessageCenter, jumpOrderPage, spinning } =
    useSetupHook()

  return spinning ? (
    <MessageBoxSkeleton />
  ) : (
    <div className={styles['container']}>
      <Row className={styles['header']} justify="space-between">
        <span className={styles['title']}>消息通知</span>
        <span className="btn-link" onClick={handleJumpMessageCenter}>
          {'查看全部 >>'}
        </span>
      </Row>
      <div className={styles['messageList']}>
        {dataSource.length === 0 ? (
          <div className={styles.emptyWrapper}>
            <Empty
              image={emptyImage}
              description="暂时没有新消息"
              imageStyle={{
                height: '200px',
              }}
            />
          </div>
        ) : (
          dataSource.map((record) => {
            const displayText =
              record.title && record.title.trim() !== ''
                ? record.title
                : record.content
            return (
              <div
                key={record.id}
                className={styles['messageItem']}
                onClick={() => jumpOrderPage(record)}
              >
                <div
                  className={`${styles['messageTitle']} ${
                    record?.isRead ? styles['read'] : styles['unread']
                  }`}
                >
                  {displayText}
                </div>
                <div className={styles['messageTime']}>{record.time}</div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
